import axios from 'axios';
import { QueryClient } from '@tanstack/react-query';
import { applyMasterDataQueryDefaults, installMasterDataPersistence } from './masterDataStore';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) => {
        if (axios.isAxiosError(error)) {
          const status = error.response?.status;
          if (status === 429 || status === 401 || status === 403) return false;
        }
        return failureCount < 1;
      },
      refetchOnWindowFocus: false,
    },
  },
});

installMasterDataPersistence(queryClient);
applyMasterDataQueryDefaults(queryClient);

// Refetch stays in the background. Awaiting the real promise kept dialogs and
// routes on the old screen until the list came back, while the success snackbar
// had already painted at the start of `onSuccess`.
const invalidateQueries = queryClient.invalidateQueries.bind(queryClient);
queryClient.invalidateQueries = ((...args: Parameters<QueryClient['invalidateQueries']>) => {
  void invalidateQueries(...args).catch(() => undefined);
  return Promise.resolve();
}) as QueryClient['invalidateQueries'];
